import React from 'react'
import QuestionTip from "../../common/questionTip";

class DataItem extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        if (this.props.data) {
            this.setState({
                data: this.props.data
            })
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (JSON.stringify(this.props.data) != JSON.stringify(nextProps.data)) {
            this.setState({
                data: nextProps.data
            })
        }
    }


    render() {
        if (this.state.data) {
            return (
                <ul className={`dataItem ${this.state.data.showYD ? '' : 'noYestDay'}`}>
                    <li>
                        {/*<span style={this.state.data.circleColor ? {backgroundColor: this.state.data.circleColor} : {}}*/}
                        {/*      className='itemCircle'></span>*/}
                        {this.state.data.labelText}
                        {
                            this.state.data.tooltip ? <QuestionTip title={this.state.data.tooltip}/> : ''
                        }
                    </li>
                    <li>
                        {this.state.data.unitText == '元' ? this.state.data.value / 100 : (this.state.data.value == -1 ? '0' : this.state.data.value)}
                        <span>{this.state.data.unitText}</span>
                    </li>
                    {
                        this.state.data.showYD ? <li>
                            {this.state.data.ydLabelText}：{this.state.data.unitText == '元' ? this.state.data.ydValue / 100 : (this.state.data.ydValue == -1 ? '0' : this.state.data.ydValue)}
                            {/*{ this.state.data.unitText == '%'&&this.state.data.value==-1?'':<span>{this.state.data.unitText}</span>}*/}
                            <span>{this.state.data.unitText}</span>
                        </li> : ''
                    }

                </ul>
            )
        } else {
            return '';
        }
    }
}

export default DataItem